const backendURL = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:3001";
const grafanaURLFound = process.env.REACT_APP_GRAFANA_URL || "http://localhost:6768";
export const GRAFANA_URL = grafanaURLFound
export const backendAPI = backendURL + "/api/v1"; 